import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import StarRating from "./StarRating";
import { rtrim } from "../util/utils";
import configureMeasurements, { length } from 'convert-units';

const { __, _n } = wp.i18n;

export default class ProductFilter {
  constructor(args)
  {
    this.autoApplyBreakpoint = args.autoApplyBreakpoint;
    this.pricewNumb = wNumb({
      prefix: '$',
      decimals: 0,
      thousand: ',',
    });

    this.activeFilterIndicator = document.querySelector('#activeFilterCount');
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    //Clear button handler

    document.body.addEventListener('click', this.onClearButtonClick.bind(this));
    document.body.addEventListener('click', this.onSwitchUnitsClick.bind(this));

    this.init();
  }

  init()
  {
    this.filterForm = document.querySelector('#productFiltersForm');

    if(!this.filterForm) {
      return;
    }

    this.filters = [];
    this.activeFilterParams = {};
    this.tempfilters = [];
    this.filtersApplied = false;

    this.priceRangeIndicator = this.filterForm.querySelector('#priceRangeIndicator');
    //this.starRatingIndicator = this.filterForm.querySelector('#starRatingIndicator');

    this.initCheckboxes();
    this.initRangeSliders();
    this.initStarRating();

    this.runFilter(false);
    this.attachHandlers();
  }

  runFilter(fireEvent = true)
  {
    this.setActiveFiltersParams();
    this.setQuery();
    this.updateActiveCountIndicator();

    if(fireEvent) {
      //Fire Event
      document.body.dispatchEvent( new CustomEvent('palram_filters_changed'));
    }
  }

  attachHandlers()
  {

    //Clear all

    const clearAllButtons = document.querySelectorAll('.btn-filter-clear');

    if( clearAllButtons && clearAllButtons.length > 0 ) {
      clearAllButtons.forEach( clearAllButton => {
        clearAllButton.addEventListener('click', event => {
          event.preventDefault();
          this.clearAllFilters()
        })
      });
    }

    //Apply

    const applyAll = this.filterForm.querySelector('.btn-filter-apply');

    if( applyAll ) {
      applyAll.addEventListener('click', event => {
        event.preventDefault();
        //Only run filters when they was changed
        if(this.convertFilterForCompare(this.filters) !== this.convertFilterForCompare(this.tempfilters)) {
          this.runFilter(true);
          this.filtersApplied = true;
        }
        document.body.dispatchEvent( new CustomEvent('palram_filters_applied'));
      })
    }
  }

  onFilterOpen = () =>
  {
    //only for mobile
    if(this.autoApplyBreakpoint.matches) {
      return;
    }

    //Save current filters to temp array
    this.tempfilters = this.filters.slice();
  }

  onFilterClose = () =>
  {
    //only for mobile
    if(this.autoApplyBreakpoint.matches) {
      return;
    }
    //If filters was applied by apply button do nothing
    if(this.filtersApplied) {
      this.filtersApplied = false;
      this.tempfilters = [];
      return;
    }
    //Restore filters markup if filters was not applied

    this.restoreFilters();
  }

  restoreFilters()
  {
    //Restore only if filters was changed

    if(this.convertFilterForCompare(this.filters) === this.convertFilterForCompare(this.tempfilters)) {
      this.tempfilters = [];
      return;
    }
    this.filters = this.tempfilters.slice();
    this.tempfilters = [];
    this.filters.forEach(filter => {
      switch (filter.filterType) {
        case 'price':
        case 'range_meta':
          this.restoreRangeSlider(filter);
          break;
        case 'rating':
          this.restoreStarRating(filter);
          break;
        case 'attribute':
        case 'category':
          this.restoreCheckbox(filter);
          break;
      }
    });
  }

  /**
   * Set params for filter query
   */

  setActiveFiltersParams()
  {
    const activeFilters = this.getActiveFilters();
    let params = {};

    if(activeFilters && Array.isArray(activeFilters)) {
      activeFilters.forEach(filter => {
        switch (filter.filterType) {
          case 'price':
          case 'range_meta':
            params = {...params, ...this.setRangeParams(filter)};
            break;
          case 'rating':
            let value = filter.value < 5 ? [...new Array(6 - filter.value)].map((current, index) => index + filter.value) : [5];
            params = {...params, ...{[filter.fieldName]: value.join(','),}};
            break;
          case 'attribute':
            params = {...params, ...this.setAttributeParams(filter, params)};
            break;
          case 'category':
            params = {...params, ...this.setCategoryParams(filter, params)};
            break;
        }
      });
    }

    this.activeFilterParams = Object.keys(params).length > 0 ? params : {};
  }

  setRangeParams(filter)
  {
    let data = {};
    if(undefined !== filter.value[0]) {
      data[filter.fieldName[0]] = filter.value[0];
      if(filter.unit) {
        data[filter.fieldName[0]] += filter.unit;
      }
    }
    if(undefined !== filter.value[1]) {
      data[filter.fieldName[1]] = filter.value[1];
      if(filter.unit) {
        data[filter.fieldName[1]] += filter.unit;
      }
    }

    return data;
  }

  setAttributeParams(filter, params)
  {
    let key = `filter_${filter.taxonomy}`;
    let data = {};

    data[key] = params[key] ? `${params[key]},${filter.value}` : filter.value;

    if('or' === filter.relation) {
      data[`query_type_${filter.taxonomy}`] = 'or';
    }

    return data;
  }

  setCategoryParams(filter,params)
  {
    let data = {};
    data.category = params.category ? `${params.category},${filter.value}` : filter.value;
    return data;
  }

  setQuery()
  {
    let uri = window.location.pathname;
    //Get all filter names
    const filedNames = this.getFilterFieldNames();
    let oldQuery = window.location.search;
    let params = new URLSearchParams(oldQuery);

    filedNames.forEach(field => {

      //Check if query has this param
      if(params.has(field)) {
        //Check if this field in active filters
        if( undefined !== this.activeFilterParams[field]) {
          //Update param
          params.set(field, this.activeFilterParams[field]);
        } else {
          //remove this param if not in active filters
          params.delete(field);
        }
      } else {
        if( undefined !== this.activeFilterParams[field]) {
          //set param if it was not set
          params.append(field, this.activeFilterParams[field]);
        }
      }
    });

    if(params) {
      uri += `?${params}`;
    }
    uri = rtrim(uri, '?');

    window.history.replaceState({}, "", decodeURIComponent(uri));
  }

  clearQuery()
  {
    window.history.replaceState({}, "", window.location.pathname);
  }

  initRangeSliders()
  {
    const els = this.filterForm.querySelectorAll('.range-slider');

    if(els) {
      els.forEach( el => {
        const {
          filterName,
          filterLabel,
          fieldName,
          start,
          min,
          max,
          step,
          tooltipPrefix,
          tooltipSuffix,
          tooltipDecimals,
          tooltipThousand,
          eventUpdate,
          unit,
          minmax,
        } = el.dataset;

        let startOption = JSON.parse(start);
        let connect = Array.isArray(startOption) ? [false, true, false] : 'lower';
        let tooltips = ProductFilter.formatTooltip(tooltipPrefix, tooltipSuffix, tooltipDecimals, tooltipThousand);
        let options = {
          connect,
          tooltips,
          start: startOption,
          range: {
            min: [parseFloat(min)],
            max: [parseFloat(max)],
          },
          step: parseFloat(step),
        };

        noUiSlider.create(el, options);

        let active = ! ProductFilter.isRangeSliderDefault(options.start, options.range);

        this.filters.push({
          name: filterName,
          filterType: 'price' === filterName ? filterName : 'range_meta',
          label: filterLabel,
          el,
          active,
          value: startOption,
          fieldName: JSON.parse(fieldName),
          type: 'range',
          unit: undefined !== unit ? unit : false,
          minmax: undefined !== minmax ? JSON.parse(minmax) : false,
        });

        el.noUiSlider.on('change', this.onRangeSliderSet.bind(this));

        if( undefined !== eventUpdate && 'function' === typeof this[eventUpdate] ) {
          el.noUiSlider.on('update', this[eventUpdate].bind(this));
        }
      });
    }
  }

  restoreRangeSlider(filter)
  {
    //We don't need to unbind change event here, because set method doesn't affect it
    filter.el.noUiSlider.set(filter.value);
  }

  initStarRating()
  {
    const els = this.filterForm.querySelectorAll('.filter-star-rating');

    if(els) {
      els.forEach( el => {

        const {
          filterName,
          filterLabel,
          fieldName,
        } = el.dataset;

        let starRating = new StarRating(el, {
          indicator: true,
          indicatorEl: document.querySelector('#starRatingIndicator'),
        });
        const value = starRating.getValue();

        //el.addEventListener('set.star.rating', this.updateStarIndicator.bind(this));
        el.addEventListener('set.star.rating', this.onStarRatingSet.bind(this));

        this.filters.push({
          name: filterName,
          label: filterLabel,
          filterType: 'rating',
          el,
          starRating: starRating,
          fieldName: fieldName,
          active: value > 0,
          value,
          type: 'rating'
        });
      });
    }
  }

  restoreStarRating(filter)
  {
    filter.starRating.setValue(filter.value, true);
  }

  initCheckboxes()
  {
    //Checkbox filters

    const els = this.filterForm.querySelectorAll('input[type=checkbox]');

    if( els ) {
      els.forEach(el => {

        const {
          filterName,
          filterType,
          filterRelation,
        } = el.dataset;

        el.addEventListener('change', this.onCheckboxChange.bind(this));

        let data = {
          name: filterName,
          filterType,
          el,
          active: el.checked,
          value: el.value,
          type: 'checkbox',
        };

        if('attribute' === filterType) {
          data.taxonomy = el.name;
          data.fieldName = `filter_${el.name}`;
          data.relation = filterRelation;
        } else if ('category' === filterType) {
          data.fieldName = 'category';
        }
        this.filters.push(data);
      });
    }
  }

  restoreCheckbox(filter)
  {
    filter.el.removeEventListener('change', this.onCheckboxChange);
    filter.el.checked = filter.active;
    filter.el.addEventListener('change', this.onCheckboxChange);
  }

  updatePriceIndicator( values )
  {
    if( !this.priceRangeIndicator ) {
      return;
    }

    let html = '';
    if( values && Array.isArray(values) ) {
      values = values.map( value => this.pricewNumb.to(parseFloat(value)) );

      if( ! values.some( value => value === false ) ) {
        html = `${values[0]} &ndash; ${values[1]}`;
      }
    }
    this.priceRangeIndicator.innerHTML = html;
  }

  // updateStarIndicator( event )
  // {
  //   if( ! this.starRatingIndicator ) {
  //     return;
  //   }
  //   let text = '';
  //   if( event.detail && event.detail.rating ) {
  //     text = _n(`${event.detail.rating} star and up`, `${event.detail.rating} stars and up`, event.detail.rating, 'canopia');
  //   }
  //
  //   this.starRatingIndicator.textContent = text;
  // }

  updateFilterData(index, data)
  {
    if( undefined !== this.filters[index] ) {
      this.filters[index] = {...this.filters[index], ...data};
    }
  }

  clearAllFilters()
  {
    this.filters.forEach( (filter, index) => {
      this.clearFilter(index, false);
    } );

    if(this.autoApplyBreakpoint.matches) {
      this.runFilter(true);
    }
  }

  /**
   *
   * @param index filter index
   * @param updateEvent - fire filter change function
   */

  clearFilter(index, updateEvent = false) {

    if( undefined === this.filters[index] ) {
      return;
    }

    let data = {
      active: false,
    };

    switch (this.filters[index].type) {
      case 'range':
        const {
          min,
          max,
        } = this.filters[index].el.dataset;
        data.value = [parseFloat(min), parseFloat(max)];
        this.filters[index].el.noUiSlider.set(data.value);
        break;
      case 'rating':
        data.value = 0;
        this.filters[index].starRating.clear(true);
        break;
      case 'checkbox':
        this.filters[index].el.checked = false;
        break;
    }

    this.updateFilterData(index, data);

    if(updateEvent) {
      this.onFilterChange(index);
    }
  }

  onClearButtonClick( event ) {
    const name = event.target.dataset.filterTarget || event.target.parentNode.dataset.filterTarget;

    if(!name) {
      return;
    }
    const index = this.getFilterIndexByName(name);
    this.clearFilter(index);
    this.onFilterChange(index, true);
  }

  onSwitchUnitsClick(event) {
    let button;
    if(event.target.classList.contains('btn-filter-switcher')) {
      button = event.target;
    } else if(event.target.parentElement.classList.contains('btn-filter-switcher')) {
      button = event.target.parentElement;
    } else {
      return;
    }

    //if active do nothing
    if(button.classList.contains('active')) {
      return;
    }

    const unit = button.dataset.unit;
    const filterEls = button.closest('.filter-group').querySelectorAll('.range-slider');

    if(filterEls && filterEls.length > 0) {
      const convert = configureMeasurements({ length, });
      filterEls.forEach(filterEl => {
        const filterIndex = this.getFilterIndexByName(filterEl.dataset.filterName);

        if(filterIndex === -1 || ! this.filters[filterIndex] || this.filters[filterIndex].unit === unit ) {
          return;
        }

        this.filters[filterIndex].value = [Math.floor(convert(this.filters[filterIndex].value[0])
          .from(this.filters[filterIndex].unit)
          .to(unit)), Math.ceil(convert(this.filters[filterIndex].value[1])
          .from(this.filters[filterIndex].unit)
          .to(unit))];
        this.filters[filterIndex].min = this.filters[filterIndex].minmax[unit].min;
        this.filters[filterIndex].max = this.filters[filterIndex].minmax[unit].max;

        if(this.filters[filterIndex].value[0] < this.filters[filterIndex].min) {
          this.filters[filterIndex].value[0] = this.filters[filterIndex].min;
        }

        if(this.filters[filterIndex].value[1] > this.filters[filterIndex].max) {
          this.filters[filterIndex].value[1] = this.filters[filterIndex].max;
        }

        this.filters[filterIndex].el.noUiSlider.updateOptions({
          range: {
            min: [this.filters[filterIndex].min],
            max: [this.filters[filterIndex].max],
          },
        });

        const labelMin = filterEl.previousElementSibling;

        if(labelMin) {
          labelMin.textContent = this.filters[filterIndex].min;
        }

        const labelMax = filterEl.nextElementSibling;

        if(labelMax) {
          labelMax.textContent = this.filters[filterIndex].max;
        }

        // const selectedButtons = document.querySelectorAll(`button[data-filter-target="${this.filters[filterIndex].name}"]`);
        //
        // if(selectedButtons && selectedButtons.length > 0) {
        //   selectedButtons.forEach(button => {
        //     const span = button.nextElementSibling;
        //
        //     if(!span) {
        //       return;
        //     }
        //
        //     const text = span.textContent;
        //     span.textContent = text.replaceAll(this.filters[filterIndex].unit, unit);
        //   });
        // }

        this.restoreRangeSlider(this.filters[filterIndex]);
        this.filters[filterIndex].unit = unit;


      });
      this.clearQuery();
      this.setActiveFiltersParams();
      this.setQuery();
      button
        .closest('.filter__unit-switch')
        .querySelectorAll('.btn-filter-switcher')
        .forEach(button => button.classList.remove('active'));
      button.classList.add('active');
    }

  }

  onFilterChange(index, force = false)
  {

    if(undefined === index) {
      //All filterd update
      return;
    }

    // Run filters only on desktop, but clear update should run anyway

    if(this.autoApplyBreakpoint.matches || force) {
      this.runFilter(true);
    }
  }

  updateActiveCountIndicator()
  {
    if(this.activeFilterIndicator ) {
      let activeCount = this.getActiveFilters().length;
      this.activeFilterIndicator.textContent = activeCount > 0 ? `(${activeCount})` : '';
    }
  }

  onRangeSliderSet( values, handle, unencoded, tap, positions, noUiSlider )
  {
    const {
      min,
      max,
      filterName,
    } = noUiSlider.target.dataset;

    let filterIndex = this.getFilterIndexByName( filterName );

    if( filterIndex < 0 || undefined === this.filters[filterIndex] ) {
      return;
    }

    //Convert values
    values = Array.isArray(values) ? values.map(value => parseFloat(value)) : parseFloat(values);
    //Check if values was changed

    if(Array.isArray(values)) {
      if(values.length === this.filters[filterIndex].value.length && values.every((value, index) => value === this.filters[filterIndex].value[index])) {
        return;
      }
    } else if( values === this.filters[filterIndex].value ) {
      return;
    }

    //Update filter with new data

    if( ProductFilter.isRangeSliderDefault(values, { min: [parseFloat(min)], max: [parseFloat(max)]})) {
      this.clearFilter(filterIndex, false);
    } else {
      this.updateFilterData(filterIndex, { active: true, value: values });
    }

    this.onFilterChange(filterIndex);
  }

  onStarRatingSet(event)
  {
    const rating = event.detail.rating;
    const {
      filterName,
    } = event.target.dataset;
    const filterIndex = this.getFilterIndexByName( filterName );

    if( filterIndex < 0 || undefined === this.filters[filterIndex] ) {
      return;
    }

    if( rating === 0 ) {
      this.clearFilter(filterIndex);
    } else {
      this.updateFilterData(filterIndex, { active: true, value: rating });
    }

    this.onFilterChange(filterIndex);
  }

  onCheckboxChange(event)
  {
    const {
      filterName,
    } = event.target.dataset;

    const filterIndex = this.getFilterIndexByName( filterName );

    if(!event.target.checked) {
      this.clearFilter(filterIndex);
    } else {
      this.updateFilterData(filterIndex, { active: true });
    }

    this.onFilterChange(filterIndex);
  }

  getFilterIndexByName(name) {
    return this.filters.findIndex( elem => {
      return elem.name && elem.name === name;
    });
  }

  hasActiveFilters()
  {
    return this.getActiveFilters.length > 0;
  }

  getActiveFilters()
  {
    return this.filters.filter( filter => filter.active);
  }

  //getters
  get params()
  {
    return this.activeFilterParams;
  }

  getFilterFieldNames()
  {
    let names = this.filters.map(filter => {
      return undefined !== filter.relation ? [filter.fieldName, `query_type_${filter.taxonomy}` ] : filter.fieldName;
    }).flat();

    return names.filter((value, index, self) => self.indexOf(value) === index);
  }

  getForm()
  {
    return this.filterForm;
  }

  static isRangeSliderDefault(values, range)
  {
    if(Array.isArray(values)) {
      return values[0] === range.min[0] && values[1] === range.max[0];
    } else {
      return values === range.min[0];
    }
  }

  static formatLabel( filter )
  {
    const {
      filterLabel,
      filterValue,
      tooltipPrefix,
      tooltipSuffix,
      tooltipDecimals,
      tooltipThousand,
    } = filter.el.dataset;

    let html = `${filterLabel}: `;
    switch (filter.type) {
      case 'range':
        let Format = ProductFilter.formatTooltip(tooltipPrefix, tooltipSuffix, tooltipDecimals, tooltipThousand);
        if( Array.isArray(filter.value) ) {
          html += filter.value.map( v => Format.to(v) ).join(' &ndash; ');
        } else {
          html += Format.to(filter.value);
        }

        break;
      case 'rating':
        html += _n(`%s star and up`, `%s stars and up`, filter.value, 'canopia').replace('%s', filter.value);
        break;
      case 'checkbox':
        if( undefined !== filterValue ) {
          html += filterValue;
        } else {
          html = filterLabel;
        }
        break;
    }
    return html;
  }

  /**
   * Format tooltip for range slider
   * @param prefix
   * @param suffix
   * @param decimals
   * @param thousand
   */
  static formatTooltip(prefix = '', suffix = '', decimals = '', thousand = '')
  {

    const sqBrackets = /(\[)(\w+)(\])/g;

    if( sqBrackets.test(suffix) ) {
      suffix = suffix.replace(sqBrackets, (match, p1, p2, p3) => {
        return `<sup>${p2}</sup>`;
      });
    }

    if(suffix) {
      suffix = ` <span class="d-none d-lg-inline">${suffix}</span>`;
    }

    return wNumb({
      prefix,
      suffix,
      decimals,
      thousand,
    });
  }

  convertFilterForCompare(filter)
  {
    if(!Array.isArray(filter) || filter.length === 0) {
      return '';
    }
    const converted = filter.map(data => {
      const { name, active, value } = data;
      return { name, active, value };
    });

    return JSON.stringify(converted);
  }
}
